import { getLanguage } from 'core/i18n';

const currentLanguage = getLanguage();

export function getNumOfDaysBetweenDates(firstDate, secondDate = null) {
    let diff = 0;
    if (!secondDate) {
        diff = (new Date() - new Date(firstDate)) / 1000 / 60 / 60 / 24;
    } else {
        diff = (new Date(secondDate) - new Date(firstDate)) / 1000 / 60 / 60 / 24;
    }

    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}

export function getDay(date) {
    return date ? new Date(date).getDate() : '';
}

export function getFullYear(date) {
    return date ? new Date(date).getFullYear() : '';
}

export function getFullYearAsString(date) {
    return date ? new Date(date).getFullYear().toString() : '';
}

export function getMonth(date) {
    return date ? `${new Date(date).getMonth() + 1}`.padStart(2, '0') : '';
}

export function getAmPm(date) {
    return new Date(date).getHours() >= 12 ? 'pm' : 'am';
}

export function getMonthNameFromDate(date, language = currentLanguage, length = 'short') {
    return new Date(date).toLocaleString(language, { month: length });
}

export function getDayNameFromDate(date, language = currentLanguage, length = 'long') {
    return new Date(date).toLocaleDateString(language, { weekday: length });
}

export function isRealYear(year) {
    return parseInt(year, 10) >= 1900;
}

export function getDayStart(date = new Date()) {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);

    return newDate;
}

export function getDateWithOffset(date, { years = 0, months = 0, days = 0, hours = 0, minutes = 0, seconds = 0 } = {}) {
    const newDate = new Date(date);

    if (years) newDate.setFullYear(newDate.getFullYear() + years);
    if (months) newDate.setMonth(newDate.getMonth() + months);
    if (days) newDate.setDate(newDate.getDate() + days);
    if (hours) newDate.setHours(newDate.getHours() + hours);
    if (minutes) newDate.setMinutes(newDate.getMinutes() + minutes);
    if (seconds) newDate.setSeconds(newDate.getSeconds() + seconds);

    return newDate;
}

export function convertToValidFormatForDate(date) {
    const [day, month, year] = date.split('/');

    return `${year}/${month}/${day}`;
}

export function formatDateToYYYYMMDD(date, separator = '-') {
    const day = String(getDay(date)).padStart(2, '0');
    const month = getMonth(date);
    const year = getFullYear(date);

    return `${year}${separator}${month}${separator}${day}`;
}

export function formatDateToMMMD(date) {
    return new Date(date).toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
}

export function formatDateToMMMYYYY(date) {
    return new Date(date).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}
